(function() { window.GUID_d0e99fab_cba3_4604_961d_8f83c0124d03 = { getGuid: function() { return "d0e99fab-cba3-4604-961d-8f83c0124d03"; } }; })();
var CS;
(function (CS) {
    class Size {
        constructor(width, height) {
            this.Width = width;
            this.Height = height;
        }
    }
    CS.LayoutHelperLeft = "LayoutHelperLeft";
    CS.LayoutHelperRight = "LayoutHelperRight";
    CS.LayoutHelperTop = "LayoutHelperTop";
    CS.LayoutHelperBottom = "LayoutHelperBottom";
    class LayoutElement {
        static get AllLayoutHelperClasses() {
            return CS.LayoutHelperLeft + ' ' + CS.LayoutHelperLeft + ' ' + CS.LayoutHelperLeft + ' ' + CS.LayoutHelperLeft;
        }
        constructor(element, calculateSizeOnly = false) {
            this.UIElement = element;
            this.CalculateSize();
            if (!calculateSizeOnly) {
                this.CalculatePosition();
            }
        }
        CalculateSize() {
            let width = this.UIElement.outerWidth();
            let height = this.UIElement.outerHeight();
            this.Bottom = null;
            this.Right = null;
            this.HMiddle = null;
            this.VMiddle = null;
            this.Width = width;
            this.HalfOfWidth = width / 2;
            this.Height = height;
            this.HalfOfheight = height / 2;
        }
        CalculatePosition() {
            let offset = this.UIElement.offset();
            this.Left = offset.left;
            this.Top = offset.top;
            let curleft, curtop = 0;
            let obj = this.UIElement[0];
            if (obj.offsetParent) {
                do {
                    curleft += obj.offsetLeft + jQuery.css(obj, "borderLeftWidth", true);
                    curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
                    obj = obj.offsetParent;
                } while (obj);
            }
            if (this.Top - curtop > 15) {
                var scrollLeft = CS.win.scrollLeft();
                var scrollTop = CS.win.scrollTop();
                this.Left -= scrollLeft;
                this.Top -= scrollTop;
            }
            this.Bottom = this.Top + this.Height;
            this.Right = this.Left + this.Width;
            this.HMiddle = this.Left + this.HalfOfWidth;
            this.VMiddle = this.Top + this.HalfOfheight;
        }
    }
    CS.LayoutElement = LayoutElement;
    function PositionTargetRefToSourceAndWindows(elementReference, elementToPosition) {
        var forcedOnTop = false;
        var forcedOnBottom = false;
        if (elementReference.hasClass('ForcedOnTop')) {
            forcedOnTop = true;
        }
        else if (elementReference.hasClass('ForcedOnBottom')) {
            forcedOnBottom = true;
        }
        var offsetHoriBody = CS.body.offset().left;
        var offsetVertBody = CS.body.offset().top;
        var offset = elementReference.offset();
        //offset.left -= offsetHoriBody;
        //offset.top -= offsetVertBody;
        var sourceWidth = elementReference[0].offsetWidth;
        var sourceHeight = elementReference[0].offsetHeight;
        var scrollWindowTop = CS.win.scrollTop();
        var width = CS.win.width();
        var height = CS.win.height();
        var middleH = width / 2;
        var middleV = height / 2 + scrollWindowTop;
        var sourceMiddleH = sourceWidth / 2 + offset.left;
        var sourceMiddleV = sourceHeight / 2 + offset.top;
        var cssMenu = null;
        var top = null;
        var left = null;
        var right = null;
        var bottom = null;
        //fix offset dans chrome android zoomed
        var curleft = 0;
        var curtop = 0;
        var obj = elementReference[0];
        if (obj.offsetParent) {
            do {
                curleft += obj.offsetLeft + jQuery.css(obj, "borderLeftWidth", true);
                curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
                obj = obj.offsetParent;
            } while (obj);
        }
        if (offset.top - curtop > 15) {
            offset.left -= CS.win.scrollLeft();
            offset.top -= CS.win.scrollTop();
        }
        var customClass = '';
        let rightPos = (width - offset.left - offsetHoriBody) - sourceWidth;
        let leftPos = (offset.left - offsetHoriBody);
        if (rightPos < 0) {
            rightPos = 0;
        }
        if (leftPos < 0) {
            leftPos = 0;
        }
        if (sourceMiddleH > middleH) {
            left = 'auto';
            right = rightPos + 'px';
            customClass = CS.LayoutHelperRight;
        }
        else {
            left = leftPos + 'px';
            right = 'auto';
            customClass = CS.LayoutHelperLeft;
        }
        let bottomPos = (height - offset.top + scrollWindowTop - offsetVertBody);
        let topPos = offset.top - scrollWindowTop + sourceHeight - offsetVertBody;
        if (bottomPos < 0) {
            bottomPos = 0;
        }
        if (topPos < 0) {
            topPos = 0;
        }
        if ((sourceMiddleV > middleV || forcedOnTop) && !forcedOnBottom) {
            top = 'auto';
            bottom = bottomPos + 'px';
            customClass += ' ' + CS.LayoutHelperBottom;
        }
        else {
            top = topPos + 'px';
            bottom = 'auto';
            customClass += ' ' + CS.LayoutHelperTop;
        }
        var lastHeight = elementToPosition.outerHeight(true);
        /*Permet de faire en sorte que le bottom a 0 n'influcen pas le height une fois setter'*/
        if (elementToPosition.data('lastHeight') != null) {
            lastHeight = elementToPosition.data('lastHeight');
        }
        else {
            elementToPosition.data('lastHeight', lastHeight);
        }
        if (top == "auto") {
            if (bottomPos + lastHeight > height * 0.95) {
                top = 0;
            }
        }
        else if (bottom == "auto") {
            if (topPos + lastHeight + sourceHeight + offsetVertBody >= height * 0.95) {
                bottom = 0;
            }
        }
        elementToPosition.css({
            left: left, right: right, top: top, bottom: bottom
        });
        return customClass;
    }
    CS.PositionTargetRefToSourceAndWindows = PositionTargetRefToSourceAndWindows;
    function GetSize(element, innerSize = false) {
        var elementHtml = element[0];
        var size = {
            Width: elementHtml.getBoundingClientRect().width, Height: elementHtml.getBoundingClientRect().height
        };
        size.Width = size.Width - Math.floor(size.Width - element.width());
        size.Height = size.Height - Math.floor(size.Height - element.height());
        return size;
    }
    CS.GetSize = GetSize;
    function MakeAllElementsSizeEqualToBiggerOne(elements) {
        var biggerSize = new Size(0, 0);
        $.each(elements, function (e) {
            var $this = $(this);
            var size = GetSize($this, true);
            if (biggerSize.Width < size.Width) {
                biggerSize.Width = size.Width;
            }
            if (biggerSize.Height < size.Height) {
                biggerSize.Height = size.Height;
            }
        });
        $.each(elements, function (e) {
            var $this = $(this);
            $this.css({
                height: biggerSize.Height.toFixed(2) + 'px',
                width: biggerSize.Width.toFixed(2) + 'px'
            });
        });
    }
    CS.MakeAllElementsSizeEqualToBiggerOne = MakeAllElementsSizeEqualToBiggerOne;
})(CS || (CS = {}));

//# sourceMappingURL=LayoutHelper.js.map
